import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

/**
 * Wraps routes that require auth. Three states:
 *   • loading (null user, loading=true) → render the loading placeholder
 *   • authenticated (user is a user object) → render children
 *   • unauthenticated (user === false) → redirect to /app/login
 */
export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        className="min-h-screen w-full flex items-center justify-center"
        style={{ backgroundColor: "#080419", color: "rgba(245,239,227,0.6)", fontFamily: "'Courier Prime', monospace" }}
        data-testid="protected-loading"
      >
        Loading…
      </div>
    );
  }

  if (!user || user === false) {
    return (
      <Navigate
        to="/app/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  return children;
}
